import wrongSlide_bg from'../images/wrongSlide_bg.mp4'
import classroomMainCut_bg_presentation1 from'../images/classroomMainCut_bg_presentation1.png'
import classroomMainCut_bg_presentation2 from'../images/classroomMainCut_bg_presentation2.png'
import classroomMainCut_bg_presentation4 from'../images/classroomMainCut_bg_presentation4.png'
import classroomMainCut_bg_presentation6 from'../images/classroomMainCut_bg_presentation6.png'
import phoebeGreeting from'../images/scene_greeting.png'
import ryderGreeting from'../images/ryderGreeting.png'
import ryderTakingOffJumper from'../images/ryderTakingOffJumper.png'
import ryderBendingOver4 from'../images/ryderBendingOver4.mp4'
import ryderCloserLook from'../images/ryderCloserLook.mp4'
import stacyShowingPussy from'../images/stacyShowingPussy.png'
import stacyGettingNaked from'../images/stacyGettingNaked.png'
import stacyOnTableArousedBG from'../images/stacyOnTableArousedBG.png'
import stacyClitorisQuestion from'../images/stacyClitorisQuestion.mp4'
import stacyTouchingTits from'../images/stacyTouchingTits.mp4'
import stacyThighPetting from'../images/stacyThighPetting.mp4'
import stacyOnTableEyesOpen from'../images/stacyOnTableEyesOpen.png'
import wipingDeskBG from'../images/wipingDeskBG.mp4'
import stacyTeachMasturbation2 from'../images/stacyTeachMasturbation2.mp4'
import ryderInsta from'../images/ryderInsta.png'
import masturbationGameVID from'../images/masturbationGameVID.mp4'
import masturbationGameVID2 from'../images/masturbationGameVID2.mp4'

const gallery = [
  [0, "Chapter 1", 0],
  [phoebeGreeting, "0", 1],
  [ryderGreeting, "0", 2],
  [classroomMainCut_bg_presentation1, "0", 3],
  [classroomMainCut_bg_presentation2, "0", 4],
  [wrongSlide_bg, "0", 5],
  [ryderTakingOffJumper, "0", 6],
  [ryderBendingOver4, "0", 7],
  [classroomMainCut_bg_presentation4, "0", 8],
  [ryderCloserLook, "0", 9],
  [classroomMainCut_bg_presentation6, "0", 10],
  [stacyShowingPussy, "0", 11],

  [0, "Chapter 2", 12],
  [stacyGettingNaked, "0", 13],
  [stacyOnTableArousedBG, "0", 14],
  [stacyClitorisQuestion, "0", 15],
  [stacyTouchingTits, "0", 16],
  [stacyThighPetting, "0", 17],
  [stacyTeachMasturbation2, "0", 18],
  [masturbationGameVID, "0", 19],
  [masturbationGameVID2, "0", 20],
  [stacyOnTableEyesOpen, "0", 21],
  [wipingDeskBG, "0", 22],
  [ryderInsta, "0", 23],
];

export default gallery;
